/**
 * Quantum Metric uses these values to easily hook into DOM
 * elements for event tracking.
 *
 * @export
 * @enum {number}
 */
export enum QuantumTags {
  AccountButton = 'account-button',
  CartButton = 'cart-button',
  EcommerceCatalogItem = 'ecommerce-catalog-item',
  MyPurchasesTicket = 'my-purchases-ticket',
  MyPassAndBenefits = 'my-pass-and-benefits',
}
